// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '4cfe516',
    builtAt: '2026-10-02T08:03:42.602Z',
} as const;
